<template>
	<Card>
		<div>
			<Button type="primary" @click="mySearch" style="margin-left: 10px;">搜索</Button>
			<Button @click="initSearch" style="margin-left: 10px;">重置</Button>
			<Button type="primary" @click="addIndexStandard" style="margin-left: 10px;">添加指标标准</Button>
		</div>
		<div style="width: 100% ;margin-top: 20px;">
			<Checkbox-group v-model="selectDay">
				<Checkbox label="1">星期一</Checkbox>
				<Checkbox label="2">星期二</Checkbox>
				<Checkbox label="3">星期三</Checkbox>
				<Checkbox label="4">星期四</Checkbox>
				<Checkbox label="5">星期五</Checkbox>
				<Checkbox label="6">星期六</Checkbox>
				<Checkbox label="7">星期天</Checkbox>
			</Checkbox-group>
			<Table :columns="defaultColumns" :data="datas" ref="table" :cellClassName="rowClassName">
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id" :data-index="index"
						@click="edit">编辑</Button>
					<Button type="error" size="small" :data-id="row.id" @click="del">删除</Button>
				</template>
			</Table>
		</div>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<Modal v-model="addSingleModal" title="添加默认需求">
			<Form :model="formItem" :label-width="100">
				<FormItem label="指标名称">
					<Input v-model="formItem.alarm_name" style="width: 200px;margin-left: 10px;">
					</Input>
				</FormItem>
				<FormItem label="标准类型">
					<Select v-model="formItem.alarm_type" style="width: 200px;margin-left: 10px;">
						<Option v-for="item in alarmTypeList" :value="item.value" :key="item.value">
							{{ item.label}}
						</Option>
					</Select>
				</FormItem>
				<FormItem label="指标描述">
					<Input v-model="formItem.alarm_detail" type="textarea" :rows="4" style="width: 200px;margin-left: 10px;">
					</Input>
				</FormItem>
				<FormItem label="是否暂停">
					<i-switch v-model="formItem.is_stop" size="large">
						<span slot="open">是</span>
						<span slot="close">否</span>
					</i-switch>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="saveSingleadPlanIndexStandard">提交</Button>
				<Button type="default" @click="addSingleModal = false">取消</Button>
			</div>
		</Modal>
	</Card>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAdvCity,
	} from "../../../api/runSet";
	import {
		getadPlanIndexStandardList,
		saveSingleadPlanIndexStandard,
		getadPlanIndexStandard,
		deladPlanIndexStandard,
		getCidTypeList,
	} from "../../../api/advManage.js";
	export default {
		name: "adv_demand_manage",
		components: {

		},

		data() {
			return {
				datas: [],
				page: 1,
				pageSize: 20,
				editStatus: 0,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				city: '',
				advCity: '',
				selectDay: [],
				copyTime: [],
				copySourceTime: [],
				tabNum: 1,
				addSingleModal: false,
				formItem: {},
				indeterminate: true,
				checkAll: false,
				indeterminateCidType: true,
				checkAllCidType: false,
				indexStandardModal: false,
				checkThreePlusStatus: false,
				alarmTypeList: [{
						value: 1,
						label: '优质率'
					},
					{
						value: 2,
						label: '成本'
					},
					{
						value: 3,
						label: '空耗'
					},
				],
				dayList: [{
						value: 1,
						label: '星期一'
					},
					{
						value: 2,
						label: '星期二'
					},
					{
						value: 3,
						label: '星期三'
					},
					{
						value: 4,
						label: '星期四'
					},
					{
						value: 5,
						label: '星期五'
					},
					{
						value: 6,
						label: '星期六'
					},
					{
						value: 7,
						label: '星期天'
					},
				],
				cityList: [],
				cidTypeList: [],
				defaultColumns: [{
						"title": "序号",
						"type": "index",
						"align": 'center',
						"width": '150px'
					},
					{
						"title": "指标名称",
						"key": "alarm_name",
						"align": 'center',
						"width": '150px'
					},
					{
						"title": "指标类型",
						"key": "alarm_type_name",
						"align": 'center',
					},
					{
						"title": "指标描述",
						"key": "alarm_detail",
						"align": 'center',
					},
					{
						"title": "指标状态",
						"key": "stop_status",
						"align": 'center',
					},
					{
						"title": "操作",
						"slot": "action",
						"align": 'center',
						"width": '200px'
					},
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();

		},
		methods: {

			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list;
				this.getList();
			},
			mySearch(e) {
				this.page = 1;
				this.getList();
			},
			rowClassName(row, index) {
				if (row.pyq_form_num == 0) {
					return "table-blue-row";
				} else {
					return "table-black-row";
				}
			},
			initSearch() {
				this.city = '';
				this.checkThreePlusStatus = false;
				this.getList();
			},
			addIndexStandard() {
				this.addSingleModal = true;
			},
			async getList() {
				let that = this;
				let data = this.$data;
				data.token = that.token;
				let res = await getadPlanIndexStandardList(that, data);
				that.datas = res.data.list;
			},
			async saveSingleadPlanIndexStandard() {
				let that = this;

				let data = {
					token: that.token,
					data: that.formItem
				};
				let res = await saveSingleadPlanIndexStandard(that, data);
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.addSingleModal = false;
					that.getList();
				}
			},
			handleCheckAll() {
				if (this.indeterminate) {
					this.checkAll = false;
				} else {
					this.checkAll = !this.checkAll;
				}
				this.indeterminate = false;

				if (this.checkAll) {
					for (let i in this.dayList) {
						this.formItem.day_type.push(this.dayList[i].value);
					}
				} else {
					this.formItem.day_type = [];
				}
			},
			checkAllGroupChange(data) {
				if (data.length === 7) {
					this.indeterminate = false;
					this.checkAll = true;
				} else if (data.length > 0) {
					this.indeterminate = true;
					this.checkAll = false;
				} else {
					this.indeterminate = false;
					this.checkAll = false;
				}
			},
			handleCheckAllCidType() {
				if (this.indeterminateCidType) {
					this.checkAllCidType = false;
				} else {
					this.checkAllCidType = !this.checkAllCidType;
				}
				this.indeterminateCidType = false;

				if (this.checkAllCidType) {
					for (let i in this.cidTypeList) {
						this.formItem.adv_type.push(this.cidTypeList[i].id);
					}
				} else {
					this.formItem.adv_type = [];
				}
			},
			// 编辑投放计划
			async edit(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id,
				};
				let res = await getadPlanIndexStandard(that, data);
				console.log(res)
				if (res.code == 1) {
					that.formItem = res.data.item;
					that.addSingleModal = true;
				}
			},
			// 删除账户
			del(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await deladPlanIndexStandard(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			checkAllGroupChangeCidType(data) {
				let len = this.cidTypeList.length
				if (data.length === len) {
					this.indeterminateCidType = false;
					this.checkAllCidType = true;
				} else if (data.length > 0) {
					this.indeterminateCidType = true;
					this.checkAllCidType = false;
				} else {
					this.indeterminateCidType = false;
					this.checkAllCidType = false;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},

		},
	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #0055ff;
	}

	/deep/ .ivu-table .table-black-row td {
		color: #ffff00;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	.first {
		background-color: #d47e83;

		color: #fff;

	}

	.check-threeplus-false {
		color: cornflowerblue;
	}

	.check-threeplus-true {
		color: #fff;
	}

	.second {

		background-color: #277dd3;
		cursor: pointer;
		color: #fff;

	}

	.is_stop_city {
		background-color: #9c4e00;
		cursor: pointer;
		color: #fff;
	}
</style>